import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import PowerCalculator from './pages/PowerCalculator';
import FAQ from './pages/FAQ';
import IzmirChipTuning from './pages/IzmirChipTuning';
import IzmirChipTuningTR from './pages/IzmirChipTuningTR';
import EmbedCalculator from './pages/EmbedCalculator';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/calculator" element={<PowerCalculator />} />
          <Route path="/embed/calculator" element={<EmbedCalculator />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/izmir-chip-tuning" element={<IzmirChipTuning />} />
          <Route path="/tr/izmir-chip-tuning" element={<IzmirChipTuningTR />} />
          <Route path="/tr/gizlilik" element={<PrivacyPolicy lang="tr" />} />
          <Route path="/en/privacy" element={<PrivacyPolicy lang="en" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
          {/* Legacy path redirects — keep in sync with LEGACY_REDIRECTS in seoConfig.js */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/blog" element={<Navigate to="/" replace />} />
          <Route path="/parts" element={<Navigate to="/calculator" replace />} />
          <Route path="/parts/stage3" element={<Navigate to="/calculator" replace />} />
          <Route path="/tr" element={<Navigate to="/tr/izmir-chip-tuning" replace />} />
          <Route path="/tr/home" element={<Navigate to="/tr/izmir-chip-tuning" replace />} />
          <Route path="/tr/anasayfa" element={<Navigate to="/tr/izmir-chip-tuning" replace />} />
          <Route path="/privacy" element={<Navigate to="/en/privacy" replace />} />
          {/* Caddy answers unknown paths with HTTP 404 + build/404.html (written by scripts/prerender.js) */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
